module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (60).3b241ed4.jpg";